<div class="claim-information-detail">
  <div class="claim-information-grid-container">

    <div class="grid-item claim-information-partner">
      <label class="grid-item-label">Partner</label>
      <app-tooltip [message]="$safeNavigationMigration(claimInformation?.partner) | prettyPrintReference">
        <span class="claim-detail-text"
        data-cy="claim-information-partner">{{$safeNavigationMigration(claimInformation?.partner) | prettyPrintReference | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-supplying-packing-plant">
      <label class="grid-item-label">Supplying packing plant</label>
      <app-tooltip [message]="$safeNavigationMigration(claimInformation?.supplyingPackingPlant) | prettyPrintReference">
        <span class="claim-detail-text"
        data-cy="claim-information-supplying-packing-plant">{{$safeNavigationMigration(claimInformation?.supplyingPackingPlant) | prettyPrintReference | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-claim-code">
      <label class="grid-item-label">Claim code</label>
      <app-tooltip [message]="$safeNavigationMigration(claimInformation?.claimCode) | prettyPrintReference">
        <span class="claim-detail-text"
        data-cy="claim-information-claim-code">{{$safeNavigationMigration(claimInformation?.claimCode) | prettyPrintReference | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-material">
      <label class="grid-item-label">Material</label>
      <app-tooltip [message]="$safeNavigationMigration(claimInformation?.material) | prettyPrintMaterialNumber">
        <span class="claim-detail-text"
        data-cy="claim-information-material">{{$safeNavigationMigration(claimInformation?.material) | prettyPrintMaterialNumber | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-model-type">
      <label class="grid-item-label">Model type</label>
      <app-tooltip [disable]="claimInformation?.modelType != null"
        [message]="$safeNavigationMigration(claimInformation?.modelType)">
        <span class="claim-detail-text"
        data-cy="claim-information-model-type">{{$safeNavigationMigration(claimInformation?.modelType) | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-model-code">
      <label class="grid-item-label">Model code</label>
      <app-tooltip [disable]="claimInformation?.modelCode != null"
        [message]="$safeNavigationMigration(claimInformation?.modelCode)">
        <span class="claim-detail-text"
        data-cy="claim-information-model-code">{{$safeNavigationMigration(claimInformation?.modelCode) | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-lot-number">
      <label class="grid-item-label">LOT number</label>
      <app-tooltip [disable]="claimInformation?.lotNumber != null"
        [message]="$safeNavigationMigration(claimInformation?.lotNumber)">
        <span class="claim-detail-text"
        data-cy="claim-information-lot-number">{{$safeNavigationMigration(claimInformation?.lotNumber) | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-mcdr-number">
      <label class="grid-item-label">MCDR</label>
      <app-tooltip [disable]="claimInformation?.mcdrNumber != null"
        [message]="$safeNavigationMigration(claimInformation?.mcdrNumber)">
        <span class="claim-detail-text"
        data-cy="claim-information-mcdr">{{$safeNavigationMigration(claimInformation?.mcdrNumber) | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-subject">
      <label class="grid-item-label">Subject</label>
      @if (claimInformation?.subject) {
        <app-tooltip
          [disable]="claimInformation?.subject != null"
          [message]="$safeNavigationMigration(claimInformation?.subject)">
          <span class="claim-detail-text subject"
          data-cy="claim-information-subject">{{$safeNavigationMigration(claimInformation?.subject) | undefinedValue}}</span>
        </app-tooltip>
      }
      @if (!claimInformation?.subject) {
        <app-warning-inline
          [attr.data-cy]="'claim-information-subject-required-warning'"
          [warningInlineLabel]="requiredForSendLabel"
        [warningType]="WarningEnum.WARNING_SEND"></app-warning-inline>
      }
    </div>

    <div class="grid-item claim-information-spo-number">
      <label class="grid-item-label">SPO number</label>
      <app-tooltip [disable]="claimInformation?.spoNumber != null"
        [message]="$safeNavigationMigration(claimInformation?.spoNumber)">
        <span class="claim-detail-text spo-number"
        data-cy="claim-information-spo-number">{{$safeNavigationMigration(claimInformation?.spoNumber) | undefinedValue}}</span>
      </app-tooltip>
    </div>

    <div class="grid-item claim-information-description">
      <label class="grid-item-label">Description</label>
      @if (claimInformation?.description) {
        <app-tooltip [disable]="claimInformation?.description != null"
          [message]="$safeNavigationMigration(claimInformation?.description)">
          <span class="claim-detail-text description"
          data-cy="claim-information-description">{{$safeNavigationMigration(claimInformation?.description) | undefinedValue}}</span>
        </app-tooltip>
      }
      @if (!claimInformation?.description) {
        <app-warning-inline
          [attr.data-cy]="'claim-information-description-required-warning'"
          [warningInlineLabel]="requiredForSendLabel"
        [warningType]="WarningEnum.WARNING_SEND"></app-warning-inline>
      }
    </div>

    @if (claimInformation?.sentDate) {
      <div class="grid-item claim-information-sentDate">
        <label class="grid-item-label">Sent date</label>
        <app-tooltip [message]="$safeNavigationMigration(claimInformation?.sentDate)">
          <span class="claim-detail-text"
          data-cy="claim-information-sentDate">{{$safeNavigationMigration(claimInformation?.sentDate) | date:'dd-MM-yyyy HH:mm:ss'}}</span>
        </app-tooltip>
      </div>
    }

    @if (claimInformation?.email) {
      <div
        [ngClass]="claimInformation?.sentDate ? 'grid-item claim-information-email' : 'claim-information-email-first-position' ">
        <label class="grid-item-label">Email</label>
        <app-tooltip [message]="$safeNavigationMigration(claimInformation?.email)">
          <span class="claim-detail-text"
          data-cy="claim-information-email">{{claimInformation?.email}}</span>
        </app-tooltip>
      </div>
    }

  </div>
  @if (fileManagerOffline) {
    <div>
      <app-attachments-list-display-error
      [refreshAttachments]="refreshAttachments"></app-attachments-list-display-error>
    </div>
  } @else {
    <app-attachments-list-display [attachments]="attachments"
      [directory]="directory"
    [requiredAttachments]="requiredAttachments"></app-attachments-list-display>
  }

</div>
